// extracted by mini-css-extract-plugin
module.exports = {"main":"StatusUserNotAvailable_main__yc6Nk","icon":"StatusUserNotAvailable_icon__6JBlp","text":"StatusUserNotAvailable_text__CNT_l"};